<mat-radio-group class="example-radio-group" [(ngModel)]="partialPayment" (ngModelChange)="updatePaymentType()">
  <mat-radio-button color="primary" [value]="false">
    <span>Plată integrală <strong>{{offer?.discountedTotal | roncurrency}}</strong></span>
  </mat-radio-button>
  <mat-radio-button color="primary" [value]="true" [disabled]="offer?.disablePartialPayment">
    <span>Avans <strong>{{getPartialPaymentAmount()| roncurrency}}</strong> și rest de plată <u>cash</u>&nbsp;<strong>{{getPaymentAmountLeft()| roncurrency}}</strong></span>
    <span *ngIf="offer?.disablePartialPayment"> (nu este suportat pentru producatorul selectat)</span>
  </mat-radio-button>
</mat-radio-group>
